export function formatNaira(kobo: number): string {
  return Math.abs(Math.round(kobo / 100)).toLocaleString("en-NG");
}

export function toKobo(nairaAmount: number): number {
  return Math.round(nairaAmount * 100);
}

export function formatDateShort(iso: string): string {
  return new Date(iso).toLocaleDateString("en-NG", { month: "short", day: "numeric" });
}

export function formatDateTime(iso: string): string {
  const d = new Date(iso);
  return (
    d.toLocaleDateString("en-NG", { month: "short", day: "numeric" }) +
    ", " +
    d.toLocaleTimeString("en-NG", { hour: "numeric", minute: "2-digit" })
  );
}

export function formatRelative(iso: string | null): string {
  if (!iso) return "Never synced";
  const diffMs = Date.now() - new Date(iso).getTime();
  const mins = Math.round(diffMs / 60000);
  if (mins < 1) return "Just now";
  if (mins < 60) return `${mins} min ago`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `${hours} hr ago`;
  const days = Math.round(hours / 24);
  return `${days} day${days === 1 ? "" : "s"} ago`;
}
